// Help in the command bar (TI's registry, src/chrome/commands): "Open help" for the board in view, and its tips again,
// so Ctrl or ⌘ K finds them as it finds everything else.

import { CircleHelp, Lightbulb } from "lucide-react";
import { BOARD_KINDS } from "../../shared/boardKinds";
import { addCommands } from "../chrome/commands/registry";
import { set } from "../state/store";
import { showTour } from "./tips";

addCommands("help", ({ kind, phone }) => [
  { id: "help", group: "Actions", label: "Open help", hint: kind === "canvas" ? "This board's keys, things to ask and how to do anything" : `For ${BOARD_KINDS[kind].name.toLowerCase()} boards: keys, things to ask, how-tos`, icon: <CircleHelp size={15} />, keywords: "help how do i docs guide what can i say tips support question", run: () => set({ panel: "help", panelArg: null }) },
  ...(phone ? [] : [{ id: "tips", group: "Actions", label: "Show this board's tips", hint: "The pointers you saw the first time", icon: <Lightbulb size={15} />, keywords: "tips tour pointers onboarding getting started", run: () => showTour(kind) }]),
]);
